import { Dialog, Box, Paper } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from './constants';

export const StyledDialog = styled(Dialog)<{ align?: string }>`
  && .MuiDialog-paper {
    margin: 1rem 2rem;
    max-height: 99vh;
    align-self: ${(props) => (props.align ? props.align : `center`)};
  }

  && .MuiDialogTitle-root {
    padding: 0.65rem 1rem;
    font-weight: 600;
  }

  && .MuiDialogContent-root {
    padding: 1rem 1.5rem;
    min-width: 600px;
    max-width: 100%;

    && .MuiTextField-root {
      width: 100%;
      padding: 5rem;
    }
  }
  && .MuiDialogActions-root {
    padding: 0.75rem 1.5rem;
  }
`;

export const ColumnVisibilityStyledDialog = styled(Dialog)<{
  align?: string;
}>`
  && .MuiDialog-paper {
    margin: 1rem 2rem;
    max-height: 99vh;
    align-self: ${(props) => (props.align ? props.align : `center`)};
    width: 700px;
    max-width: 95vw;
  }

  && .MuiDialogTitle-root {
    padding: 0.5rem 1rem;
    font-weight: 600;
    font-size: 0.95rem;
  }

  && .MuiDialogContent-root {
    padding: 0.75rem 1rem;
    min-height: 200px;
    max-height: 320px;
    overflow: hidden;
  }

  && .MuiDialogActions-root {
    padding: 0.5rem 1rem;
  }
`;

const MANAGEMENT_DIALOG_HEIGHT = '874px';

export const ManagementStyledDialog = styled(Dialog)<{
  align?: string;
}>`
  && .MuiDialog-paper {
    margin: 1rem 2rem;
    align-self: ${(props) => (props.align ? props.align : `center`)};
    width: 1000px;
    max-width: 95vw;
    height: ${MANAGEMENT_DIALOG_HEIGHT};
    max-height: calc(100vh - 2rem);
  }

  && .MuiDialogTitle-root {
    padding: 0.5rem 1rem;
    font-weight: 600;
    font-size: 0.95rem;
  }

  && .MuiDialogContent-root {
    padding: 0.75rem 1rem;
    overflow-y: auto;
  }

  && .MuiDialogActions-root {
    padding: 0.5rem 1rem;
  }
`;

export const CheckboxContainer = styled(Box)<{ $rowsNeeded: number }>`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(${(props) => props.$rowsNeeded}, 1fr);
  grid-auto-flow: column;
  gap: 4px 8px;
  height: 240px;
  overflow: hidden;

  .MuiFormControlLabel-root {
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .MuiFormControlLabel-label {
    font-size: 0.8rem;
  }
`;

export const ConfirmDeleteStyledDialog = styled(Dialog)`
  & .MuiDialog-paper {
    min-width: 350px;
  }

  && .MuiDialogTitle-root {
    padding: 0.5rem 1rem;
    font-size: 0.95rem;
  }

  && .MuiDialogContent-root {
    padding: 0.5rem 1rem;
  }

  && .MuiDialogActions-root {
    padding: 0.5rem 1rem;
  }
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1299;
  background-color: transparent;
`;

export const ModalPaper = styled(Paper)`
  position: absolute;
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
  background-color: ${COLORS.white};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 1300;
  width: 320px;
  max-width: 95vw;
`;

export const ModalContent = styled.div`
  padding: 0.35rem 0;
  font-size: 0.85rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin-bottom: 0.35rem;
`;

export const ModalActions = styled(Box)`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
`;

export const TabsBar = styled(Box)`
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding-left: 1rem;
`;

export const TabPane = styled(Box)`
  padding-top: 1rem;
`;

export const DriversTableWrapper = styled(Box)`
  border: 1px solid rgba(224, 224, 224, 1);

  table {
    table-layout: fixed;
    width: 100%;
  }

  tbody td:not(.MuiTableCell-paddingCheckbox):not(.MuiTableCell-paddingNone) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const driverInputSx = {
  width: '100%',
  '& .MuiInputBase-root': {
    fontSize: '0.8rem',
    padding: '0 4px',
  },
  '& .MuiInputBase-input': {
    padding: '3px 4px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(0,0,0,0.15)',
  },
} as const;

export const DriversToolbar = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
`;

export const StatusesTableWrapper = styled(Box)`
  border: 1px solid rgba(224, 224, 224, 1);

  table {
    table-layout: fixed;
    width: 100%;
  }

  tbody td:not(.MuiTableCell-paddingCheckbox):not(.MuiTableCell-paddingNone) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const StatusesToolbar = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
`;

export const StatusesToolbarTitle = styled(Box)`
  flex: 1;
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.75);
`;

export const StatusNameCell = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StatusVisibilityButton = styled.button<{ $enabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  margin-left: 8px;
  padding: 2px;
  border: none;
  background: none;
  cursor: pointer;
  color: ${(props) =>
    props.$enabled ? 'rgba(0, 0, 0, 0.54)' : 'rgba(0, 0, 0, 0.3)'};

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

export const ColorSwatch = styled(Box)<{
  $color: string | null;
  $size?: number;
}>`
  width: ${(props) => props.$size ?? 22}px;
  height: ${(props) => props.$size ?? 22}px;
  flex: none;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  background-color: ${(props) => props.$color ?? '#fff'};
  background-image: ${(props) =>
    props.$color
      ? 'none'
      : `linear-gradient(
          to top right,
          transparent calc(50% - 0.5px),
          rgba(0, 0, 0, 0.35) calc(50% - 0.5px),
          rgba(0, 0, 0, 0.35) calc(50% + 0.5px),
          transparent calc(50% + 0.5px)
        )`};
`;

export const ColorSelectButton = styled.button`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 0 2px 3px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  background-color: ${COLORS.white};
  cursor: pointer;

  .MuiSvgIcon-root {
    color: rgba(0, 0, 0, 0.54);
    margin-left: -2px;
  }

  &:hover:not(:disabled) {
    border-color: rgba(0, 0, 0, 0.87);
    background-color: rgba(0, 0, 0, 0.04);
  }

  &:focus-visible {
    outline: 2px solid rgba(25, 118, 210, 0.5);
    outline-offset: 1px;
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

export const ColorPickerBody = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin-bottom: 0.5rem;
`;

export const ColorPickerRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`;

export const colorPickerPaperSx = {
  padding: '0.5rem 0.75rem',
  borderRadius: '4px',
  width: 220,
} as const;

export const hexInputSx = {
  flex: 1,
  '& .MuiInputBase-root': {
    fontSize: '0.8rem',
    fontFamily: 'monospace',
  },
  '& .MuiInputBase-input': {
    padding: '6px 8px',
  },
} as const;
